import { render, staticRenderFns } from "./StudentLearnRecord.vue?vue&type=template&id=0d81d795"
import script from "./StudentLearnRecord.vue?vue&type=script&lang=js"
export * from "./StudentLearnRecord.vue?vue&type=script&lang=js"
import style0 from "./StudentLearnRecord.vue?vue&type=style&index=0&id=0d81d795&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports